import { signal, WritableSignal } from "@angular/core";
import { Validators } from "@angular/forms";
import { ConfigInput, ConfigSelected } from "app/interfaces/interfaces";
import { maxYesterdayColombiaValidator } from "./functions.shared";

export const MAIN_INCOME_MIN = 1_750_000;
export const MAIN_INCOME_MAX = 30_000_000;

export function isMainIncomeInRange(value: unknown): boolean {
  const numeric = Number(String(value ?? '').replace(/,/g, '').trim());
  return Number.isFinite(numeric) && numeric >= MAIN_INCOME_MIN && numeric <= MAIN_INCOME_MAX;
}

const MAIN_INCOME_VALIDATORS = [
  Validators.required,
  Validators.min(MAIN_INCOME_MIN),
  Validators.max(MAIN_INCOME_MAX),
];

export const COUNTRIES: string[] = [
  'BOSNIA HERZEGOVINA',
  'BOTSWANA',
  'BOUVET, ISLA',
  'BRASIL',
  'BELIZE',
  'INDICO, OCEANO (TERITORIO BRITANICO DEL)',
  'SALOMON, ISLAS',
  'VIRGENES, ISLAS (REINO UNIDO)',
  'BRUNEI',
  'BULGARIA',
  'MYANMAR',
  'BURUNDI',
  'BIELORRUSIA',
  'CAMBOYA',
  'CAMERUN',
  'CANADA',
  'CANTON Y ENDERBURY, ISLAS',
  'CABO VERDE',
  'CAIMAN, ISLAS',
  'REPUBLICA CENTROAFRICANA',
  'SRILANKA',
  'CHAD',
  'CHILE',
  'CHINA',
  'TAIWAN',
  'CHRISTMAS, ISLA',
  'COCOS, ISLAS',
  'COLOMBIA',
  'COMORES',
  'MAYOTTE',
  'CONGO',
  'REPUBLICA DEMOCRATICA DEL CONGO',
  'COOK, ISLAS',
  'COSTA RICA',
  'CROACIA',
  'CUBA',
  'CHIPRE',
  'REPUBLICA CHECA',
  'BENIN',
  'DINAMARCA',
  'DOMINICA',
  'REPUBLICA DOMINICANA',
  'REINA MAUD, TIERRA DE LA',
  'ECUADOR',
  'SALVADOR, EL',
  'GUINEA ECUATORIAL',
  'ETIOPIA',
  'ERITREA',
  'ESTONIA',
  'FAEROES, ISLAS',
  'MALVINAS, ISLAS',
  'FIDJI, ISLAS',
  'FINLANDIA',
  'FRANCE, METROPOLITAN',
  'FRANCIA',
  'GUAYANA FRANCESA',
  'POLINESIA FRANCESA',
  'FRENCH SOUTHERN TERRITORIES',
  'DJIBUTI',
  'GABON',
  'GEORGIA',
  'GAMBIA',
  'PALESTINA',
  'ALEMANIA',
  'GHANA',
  'GIBRALTAR',
  'KIRIBATI',
  'GRECIA',
  'GROENLANDIA',
  'GRANADA',
  'GUADALUPE',
  'GUAM',
  'GUATEMALA',
  'GUINEA',
  'GUYANA',
  'HAITI',
  'HEARD Y MCDONALD, ISLAS',
  'VATICANO',
  'HONDURAS',
  'HONG KONG',
  'HUNGRIA',
  'ISLANDIA',
  'INDIA',
  'INDONESIA',
  'IRAN',
  'IRAQ',
  'IRLANDA',
  'ISRAEL',
  'ITALIA',
  'COSTA DE MARFIL',
  'JAMAICA',
  'JAPON',
  'JOHNSTON, ISLA',
  'KAZAJSTAN',
  'JORDANIA',
  'KENIA',
  'COREA DEL NORTE',
  'COREA DEL SUR',
  'KUWAIT',
  'KIRGUIZISTAN',
  'LAOS',
  'LIBANO',
  'LESOTO',
  'LETONIA',
  'LIBERIA',
  'LIBIA',
  'LIECHTENSTEIN',
  'LITUANIA',
  'LUXEMBURGO',
  'MACAO',
  'MADAGASCAR',
  'MALAWI',
  'MALASIA',
  'MALDIVAS, ISLAS',
  'MALI',
  'MALTA',
  'MARTINICA',
  'MAURITANIA',
  'MAURICIO',
  'MEJICO',
  'MIDWAY, ISLAS',
  'MONACO',
  'MONGOLIA',
  'REPUBLICA DE MOLDAVIA',
  'MONTENEGRO',
  'MONTSERRAT',
  'MARRUECOS',
  'MOZAMBIQUE',
  'OMAN',
  'NAMIBIA',
  'NAURU',
  'NEPAL',
  'PAISES BAJOS',
  'ANTILLAS HOLANDESAS',
  'ARUBA',
  'NUEVA CALEDONIA',
  'VANUATU',
  'NUEVA ZELANDA',
  'NICARAGUA',
  'NIGER, REPUBLICA DE',
  'NIGERIA',
  'NIUE',
  'NORFOLK, ISLA',
  'NORUEGA',
  'NORTHERN MARIANA ISLANDS',
  'UNITED STATES MINOR OUTLING ISLANDS',
  'PACIFICO, ISLAS',
  'ESTADOS FEDERADOS DE MICRONESIA',
  'MARSHALL, ISLAS',
  'PALAU',
  'PAKISTAN',
  'PANAMA',
  'PAPUA NUEVA GUINEA',
  'PARAGUAY',
  'PERU',
  'FILIPINAS',
  'PITCAIRN, ISLA',
  'POLONIA',
  'PORTUGAL',
  'GUINEA-BISSAU',
  'TIMOR',
  'PUERTO RICO',
  'QATAR',
  'REUNION',
  'RUMANIA',
  'FEDERACION RUSA',
  'RUANDA',
  'SANTA ELENA',
  'SAINT-CHISTOPHER Y NIEVES',
  'ANGUILLA',
  'SANTA LUCIA',
  'SAN PEDRO Y MIQUELON',
  'SAN VICENTE Y LAS GRANADINAS',
  'SAN MARINO',
  'SANTO TOME Y PRINCIPE',
  'ARABIA SAUDITA',
  'SENEGAL',
  'SERBIA',
  'SEYCHELLES',
  'SIERRA LEONA',
  'SIKKIM',
  'SINGAPUR',
  'ESLOVAQUIA (REPUBLICA DE ESLOVAQUIA)',
  'VIETNAM',
  'ESLOVENIA',
  'SOMALIA',
  'REPUBLICA SUDAFRICANA',
  'ZIMBABWE',
  'ESPAÑA',
  'SAHARA OCCIDENTAL',
  'SUDAN',
  'SURINAM',
  'SVALBARD Y JAN MAYEN, ISLA',
  'SWAZILANDIA',
  'SUECIA',
  'SUIZA',
  'SIRIA',
  'TADJIKISTAN',
  'TAILANDIA',
  'TOGO',
  'TOKELAU',
  'TONGA',
  'TRINIDAD Y TOBAGO',
  'EMIRATOS ARABES UNIDOS',
  'TUNEZ',
  'TURQUIA',
  'TURKMENISTAN',
  'TURKS Y CAICOS, ISLAS',
  'TUVALU',
  'UGANDA',
  'UCRANIA',
  'EX-REPUBLICA YUGOSLAVA DE MACEDONIA',
  'EGIPTO',
  'REINO UNIDO',
  'TANZANIA',
  'ESTADOS UNIDOS DE AMERICA (USA)',
  'PACIFICO, ISLAS DEL (ESTADOS UNIDOS)',
  'VIRGENES, ISLAS (ESTADOS UNIDOS)',
  'BURKINA FASO',
  'URUGUAY',
  'UZBEKISTAN',
  'VENEZUELA',
  'WAKE, ISLA DE',
  'WALLIS Y FUTUNA, ISLAS',
  'SAMOA',
  'YEMEN',
  'ZAMBIA',
  'JERUSALEM',
  'FRANJA DE GAZA',
  'CISJORDANIA',
  'ALTOS DEL GOLAN',
  'EXTRANJERO',
  'APATRIDA',
  'NACION DESCONOCIDA',
];

export const ADDRESS_INPUTS :WritableSignal<ConfigInput[]> = signal([
    { label: 'Dirección de Domicilio', subLabel: '', formName: 'address', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required, Validators.minLength(8), Validators.maxLength(55)], textError: 'Por favor escribe una dirección válida mayor a 8 y menor a 55 carácteres', showBlocker: true },
    { label: 'Barrio Domicilio', subLabel: '', formName: 'neighborhood', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required, Validators.minLength(3), Validators.maxLength(30)], textError: 'Por favor ingresa un barrio mayor a 3 y mayor a 30 caracteres', showBlocker: true },
  ]);

export const ADDRESS_SELECTORS: WritableSignal<ConfigSelected[]> = signal([
    { label: '¿Cuál es tu ocupación?', subLabel: '', formName: 'asotip', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([]), showBlocker: true },
    createZoneSelector(),
  ]);

function createZoneSelector(): ConfigSelected {
  return {
    label: 'Zona en la que vives',
    subLabel: '',
    formName: 'zone',
    placeholder: '',
    type: 'text',
    defaultValue: '',
    enabled: true,
    validation: [Validators.required],
    textError: 'Por favor selecciona una zona',
    options: signal([{ value: 1, label: 'Rural' }, { value: 2, label: 'Urbana' }]),
    showBlocker: true,
  };
}

export const INDEPMENT_INPUTS: WritableSignal<ConfigInput[]> = signal([
    { label: '¿Cuál es tu ingreso por la actividad económica principal?', subLabel: '', formName: 'income', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: MAIN_INCOME_VALIDATORS, textError: 'Por favor ingresa un valor válido', showBlocker: true },
    { label: 'Otros Ingresos', subLabel: '', formName: 'incomeExtraActivity', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: null, textError: 'Por favor ingresa un valor válido', showBlocker: true },
  ])

export const INDEPMENT_SELECTORS: WritableSignal<ConfigSelected[]> = signal([
    { label: 'Cuéntanos más de tu actividad', subLabel: '', formName: 'indact', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([]), showBlocker: true },
    { label: '¿Cuál es tu nivel educativo?', subLabel: '', formName: 'academic', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un nivel educativo', options: signal([]), showBlocker: true },
    { label: '¿Perteneces a algún grupo de protección especial constitucional?', subLabel: '', formName: 'specialProtecionProgram', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor seleccione un elemento de la lista', options: signal([]), showBlocker: true },
  ])

export const AUTOMATIC_DEBIT_INPUTS: WritableSignal<ConfigInput[]> = signal([
    {
      label: 'Número de Cuenta',
      subLabel: '',
      formName: 'accountNumber',
      placeholder: '',
      type: 'text',
      defaultValue: '',
      enabled: true,
      validation: [Validators.required],
      textError: 'Por favor ingrese un número de cuenta válido',
      showBlocker: true
    },
    {
      label: 'Día Débito',
      subLabel: '',
      formName: 'debitDay',
      placeholder: '',
      type: 'tel',
      defaultValue: '',
      enabled: true,
      validation: [Validators.required, Validators.min(1), Validators.max(31), Validators.pattern('^[0-9]+$')],
      textError: 'Por favor ingrese un día entre 1 y 31',
      showBlocker: true
    }
  ])

export const AUTOMATIC_DEBIT_SELECTORS: WritableSignal<ConfigSelected[]> = signal([
    {
      label: 'Seleccione el tipo de débito:',
      subLabel: '',
      formName: 'debitType',
      placeholder: '',
      type: 'text',
      defaultValue: '',
      enabled: true,
      validation: [Validators.required],
      textError: 'Por favor seleccione un tipo de débito',
      showBlocker: true,
      options: signal([
        { value: 'INTERNO', label: 'Débito Interno' },
        { value: 'EXTERNO', label: 'Débito Externo' }
      ])
    },
    {
      label: 'Banco a Debitar',
      subLabel: '',
      formName: 'bank',
      placeholder: '',
      type: 'text',
      defaultValue: '',
      enabled: true,
      validation: [Validators.required],
      textError: 'Por favor seleccione un banco',
      showBlocker: true,
      options: signal([])
    },
    {
      label: 'Tipo de Cuenta',
      subLabel: '',
      formName: 'accountType',
      placeholder: '',
      type: 'text',
      defaultValue: '',
      enabled: true,
      validation: [Validators.required],
      textError: 'Por favor seleccione un tipo de cuenta',
      showBlocker: true,
      options: signal([
        { value: 'Ahorros', label: 'Ahorros' },
        { value: 'Corriente', label: 'Corriente' }
      ])
    }
  ])

export const ASSOCIATED_INPUTS: WritableSignal<ConfigInput[]> = signal([
  { label: '¿Desde cuando trabajas en esa empresa?', subLabel: '', formName: 'since', placeholder: '', type: 'date', defaultValue: '', enabled: true, validation: [Validators.required, maxYesterdayColombiaValidator], textError: 'Por favor selecciona una fecha válida', showBlocker: true },
  { label: 'Si tienes código de empleado por favor digitalo', subLabel: '', formName: 'code', placeholder: 'Ingresa tu código de empleado', type: 'text', defaultValue: '', enabled: true, validation: null, textError: '', showBlocker: true },
  { label: '¿Cuál es tu ingreso por la actividad económica principal?', subLabel: '', formName: 'income', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: MAIN_INCOME_VALIDATORS, textError: 'Por favor ingresa un valor válido', showBlocker: true },
  { label: 'Otros Ingresos', subLabel: '', formName: 'incomeExtraActivity', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [], textError: 'Por favor ingresa un valor válido', showBlocker: true },
]);

export const ASSOCIATED_SELECTORS: WritableSignal<ConfigSelected[]> = signal([
  { label: '¿Cuál es tu nivel educativo?', subLabel: '', formName: 'academic', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un nivel educativo', options: signal([]), showBlocker: true },
  { label: '¿Perteneces a algún grupo de protección especial constitucional?', subLabel: '', formName: 'specialProtecionProgram', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor seleccione un elemento de la lista', options: signal([]), showBlocker: true },
])

export const PENSIONER_INPUTS: WritableSignal<ConfigInput[]> = signal([
  { label: 'Fecha de la resolución de pensión', subLabel: '', formName: 'resolution', placeholder: '', type: 'date', defaultValue: '', enabled: true, validation: [Validators.required, maxYesterdayColombiaValidator], textError: 'Por favor selecciona una fecha válida.', showBlocker: true },
  { label: '¿Desde cuándo estás pensionado?', subLabel: '', formName: 'since', placeholder: '', type: 'date', defaultValue: '', enabled: true, validation: [Validators.required, maxYesterdayColombiaValidator], textError: 'Por favor selecciona una fecha válida.', showBlocker: true },
  { label: '¿Cuál es tu ingreso por la actividad económica principal?', subLabel: '', formName: 'income', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: MAIN_INCOME_VALIDATORS, textError: 'Por favor ingresa un valor válido', showBlocker: true },
  { label: 'Otros Ingresos', subLabel: '', formName: 'incomeExtraActivity', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [], textError: 'Por favor ingresa un valor válido', showBlocker: true },
]);

export const PENSIONER_SELECTORS: WritableSignal<ConfigSelected[]> = signal([
  { label: '¿Cuál es tu nivel educativo?', subLabel: '', formName: 'academic', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un nivel educativo', options: signal([]), showBlocker: true },
  { label: '¿Perteneces a algún grupo de protección especial constitucional?', subLabel: '', formName: 'specialProtecionProgram', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor seleccione un elemento de la lista', options: signal([]), showBlocker: true },
])

export const AGRICULTURAL_INPUTS: WritableSignal<ConfigInput[]> = signal([
  { label: '¿Cuál es tu ingreso por la actividad económica principal?', subLabel: '', formName: 'income', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: MAIN_INCOME_VALIDATORS, textError: 'Por favor ingresa un valor válido', showBlocker: true },
  { label: 'Otros Ingresos', subLabel: '', formName: 'incomeExtraActivity', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [], textError: 'Por favor ingresa un valor válido', showBlocker: true },
]);

export const AGRICULTURAL_SELECTORS: WritableSignal<ConfigSelected[]> = signal([
  { label: 'Cuéntanos más de tu actividad', subLabel: '', formName: 'indact', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un valor valido', options: signal([]), showBlocker: true },
  { label: '¿Cuál es tu nivel educativo?', subLabel: '', formName: 'academic', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un nivel educativo', options: signal([]), showBlocker: true },
  { label: '¿Perteneces a algún grupo de protección especial constitucional?', subLabel: '', formName: 'specialProtecionProgram', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor seleccione un elemento de la lista', options: signal([]), showBlocker: true },
])
